import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { Router, RouterModule, RoutesRecognized } from '@angular/router';
import { QbService, WindowService } from '@app/services';
import { LoadingComponent, ToastComponent } from '@shared/components';
import { filter } from 'rxjs/operators';
import { LausdFooterComponent } from './footer/lausd.footer.component';
import { LausdHeaderComponent } from './shared/components/header/lausd.header.component';
import { NavigationMenuComponent } from './shared/components/navigation-menu/navigation-menu.component';

@Component({
  selector: 'qb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    MatSidenavModule,
    CommonModule,
    LoadingComponent,
    LausdHeaderComponent,
    ToastComponent,
    LausdFooterComponent,
    NavigationMenuComponent,
  ],
  host: { site: 'lausd' }, // This is only here to prevent warnings
})
export class LausdAppComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  landing = false;

  @ViewChild(MatSidenav) sideNav: MatSidenav;
  showMaster = false;

  constructor(
    private router: Router,
    public qb: QbService,
    private windowService: WindowService
  ) {}

  ngOnInit() {
    //   this.qb._loading$.subscribe(value => {
    //     console.log('loading', value);
    //   });

    this.windowService.isPhoneOrTablet$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      if (!value && this.sideNav && this.sideNav.opened) {
        this.sideNav.close();
      }
    });

    this.router.events
      .pipe(
        filter(event => event instanceof RoutesRecognized),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(data => {
        const showMasterValue = (<RoutesRecognized>data).state.root.firstChild?.data['showMaster'];
        this.showMaster = showMasterValue === undefined ? true : showMasterValue;
        if ((<RoutesRecognized>data).state.url == '/landing') {
          this.showMaster = false;
          this.landing = true;
        }
      });
  }
}
